import React from 'react';
import { MDBDataTable } from 'mdbreact';

export const columns = [
    {
        label: 'Company',
        field: 'company_name',
        sort: 'asc',
    },
    {
        label: 'Billing Type',
        field: 'billing_type',
        sort: 'asc',
    },
    {
        label: 'Plan',
        field: 'plan',
        sort: 'asc',
    },
    {
        label: 'Amount',
        field: 'billing_amt',
        sort: 'asc',
    },
    {
        label: 'Payment Status',
        field: 'payment_status',
        sort: 'asc',
    },
    {
        label: 'Next Bill',
        field: 'next_bill',
        sort: 'asc',
    },
    {
        label: 'Store Limit',
        field: 'store',
        sort: 'asc',
    },
    // {
    //     label: 'Ecart Limit',
    //     field: 'ecart',
    //     sort: 'asc',
    // },
    {
        label: 'Product Limit',
        field: 'product',
        sort: 'asc',
    },
    {
        label: 'Customer Limit',
        field: 'customer',
        sort: 'asc',
    },
    // {
    //     label: `POS Feature`,
    //     field: 'feature_disabled',
    //     sort: 'asc',
    // },
    {
        label: 'Disabled',
        field: 'is_disabled',
        sort: 'asc',
    },
    {
        label: 'Action',
        field: 'action',
        sort: 'disabled',
    },
];


const PosLicensingTable = props => {
    return (
        <MDBDataTable data={{
            columns: columns,
            rows: props.rows
        }}
            responsive
            searching={false}
            order={[columns[0].field, 'asc']}
            displayEntries={false}
            entries={20}
            noBottomColumns
            noRecordsFoundLabel="No records"
            pagesAmount={5}
            paginationLabel={["<", ">"]}
            disableRetreatAfterSorting
        />
    );
};

export default PosLicensingTable;